import React from "react";
import { createRoot } from "react-dom/client";
import "./index.scss";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import {
  ApolloClient,
  NormalizedCacheObject,
  ApolloProvider,
  InMemoryCache,
  createHttpLink,
  // DefaultOptions,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { verifyToken } from "utils/validation";
import { getRoutePath } from "routes/route-utils";
import { AdyenRoutesName } from "routes/route-names";
import ErrorBoundary from "ErrorBoundary";

const httpLink = createHttpLink({
  uri: `${process.env.REACT_APP_BACKEND_SERVER ||
    "https://api.adyen.digital/graphql"
    }`,
});

const authLink = setContext(async (_, { headers }) => {
  // get the authentication token from local storage if it exists
  const authToken = localStorage.getItem("authToken");
  if (authToken) {
    const validateToken = await verifyToken();
    if (!validateToken) {
      client.clearStore();
      localStorage.clear();
      window.location.replace(getRoutePath(AdyenRoutesName.LOGIN));
    }
  }
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: authToken ? `Bearer ${authToken}` : "",
    },
  };
});

// Initialize ApolloClient

// uncomment the below code to enable cache for every query
// and also uncomment the defaultOptions in client options below

// const defaultOptions: DefaultOptions = {
//   watchQuery: {
//     fetchPolicy: "no-cache",
//     errorPolicy: "ignore",
//   },
//   query: {
//     fetchPolicy: "no-cache",
//     errorPolicy: "all",
//   },
// };

const client: ApolloClient<NormalizedCacheObject> = new ApolloClient({
  cache: new InMemoryCache({
    addTypename: false,
  }),
  link: authLink.concat(httpLink),
  // defaultOptions: defaultOptions,
});

const container = document.getElementById("root");
const root = createRoot(container!);
root.render(
  <ApolloProvider client={client}>
    <React.StrictMode>
      <ErrorBoundary>
        <App client={client} />
      </ErrorBoundary>
    </React.StrictMode>
  </ApolloProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
